import { SkeletonBlock } from '../../../../../../components/ToolkitV2/Skeleton/Skeleton';

import { Spacer } from '../../../../../../helpers/genericStyles';

const Skeleton = () => {
  return (
    <>
      <SkeletonBlock w="240px" h="24px" />
      <Spacer marginBottom="M16" />
      <SkeletonBlock w="328px" h="24px" />
      <Spacer marginBottom="M16" />
      <SkeletonBlock w="240px" h="24px" />
    </>
  );
};

export { Skeleton };
